module.exports = __webpack_public_path__ + "img/循环水系统的节能优化系统.5db73cf5.png";